<template>
  <page-header :title="article.title" :links="subLinks"/>
  <div class="public-container public-container-mobile article-paper">
    <div class="article-paper-container">
      <NuxtImg
        :src="src"
        alt=""
        class="article-paper__image"
        loading="lazy"
      />
      <div class="mb-50 mt-10">
        {{ date }}
      </div>

      <h2 class="text-left article-paper-title">
        {{ article.title }}
      </h2>

      <div class="article-paper-content" v-html="parsedContent"/>
    </div>
  </div>
</template>

<script setup lang="ts">
import {computed} from "vue";
import PageHeader from "~/components/public/page-header.vue";
import {EventRecord} from "~/types/components/personal/actions";
import {getFullDate} from "~/common/date";
import {BASE_URL_HTTPS} from '~/composables/useVzFetch';

interface Props {
  article: EventRecord | undefined;
}

const props = defineProps<Props>()

const routeName = computed(() => {
  return useRoute().params.tag === 'actions' ? 'actions' : 'news';
})

const src = computed(() => {
  return props.article?.imageUrls?.detail || props.article?.imageUrls?.main || (BASE_URL_HTTPS + (props.article?.detailImg || props.article?.img))
})

const date = computed(() => {
  return getFullDate(props.article?.date)
})

const parsedContent = computed(() => {
  return props.article?.content?.replace(
    '>Рассчитать стоимость перевозки.</a>',
    '><span id="calculate-ref">Рассчитать стоимость перевозки.</span></a>'
  )
})

const subLinks = computed(() => {
  return [
    {
      link: '/' + routeName.value + '/',
      title: routeName.value === 'news' ? 'Новости' : 'Акции'
    }, {
      link: null,
      title: props.article?.title
    }
  ]
})
</script>

<style scoped lang="scss">
.article-paper {
  &-title {
    margin-bottom: 25px;
  }

  &-content {
    :deep(*) {
      font-family: Roboto, sans-serif !important;
    }

    :deep(ul) {
      padding-left: 40px;
    }
  }
}

.article-paper {
  &-container {
    padding: 48px 0;
    display: flex;
    flex-direction: column;
    color: $font-dark;
    font-size: 16px;
  }

  &__image {
    //width: fit-content;
    max-width: min(100%, 1000px);
  }

  h2 {
    text-align: left;
    font-weight: normal;
  }
}
</style>

<style scoped>
.article-paper__image {
  view-transition-name: selected-news-card;
}
</style>
